export default {
  ticket: {
    tickets: "v1/ticket",
    newTickets: "v1/fa/ticket/ticket",
    allTickets: "v1/all_ticket",
    ticketUnit: "v1/ticket/unit/{0}",
    ticket: "v1/fa/ticket/ticket/{0}",
    ticketDetailVote: "v1/ticket-detail/{0}/vote",
    ticketDetail: "v1/fa/ticket/ticket/{0}/detail",
    allTicket: "v1/fa/ticket/all-ticket/{0}",
    allTicketSms: "v1/all_ticket/{0}/sms",
    allTicketUnit: "v1/all_ticket/{0}/unit",
    ticketTag: "v1/tag",
    ticketDone: "v1/ticket/{0}/done",
    ticketAnswer: "v1/fa/ticket/ticket/{0}/answer",
    contactUs: "v1/contact_us",
    contactUsDetail: "v1/contact_us/{0}",
    contactUsAttachments: "v1/attachment/files/contact_us/{0}",
    ticketAccess: "v1/ticket_access",
    ticketAccessDetail: "v1/ticket_access/{0}",
  },
};
